<ng-container *transloco="let t; prefix: scope() + '.navigation'">
  @if (displayMode() === 'menu') {
    <button
      class="h-full text-blue-50 hover:opacity-80"
      type="button"
      aria-haspopup="true"
      aria-controls="menu"
      (click)="toggleSideNav.emit()">
      <span class="sr-only"> {{ t('menuTitle') }} </span>
      <rma-icon role="menu" glyph="menu" />
    </button>
  } @else {
    <div class="flex items-center gap-2 h-full">
      <rma-menu mode="popover" [text]="t('about')" [items]="aboutItems" />
      <rma-menu mode="popover" [text]="t('solutions')" [items]="forMenuItems" />
    </div>
  }

  <ng-template #aboutItems>
    <div class="flex flex-col gap-2 bg-white p-4 rounded-xl nc-glow-lg">
      <a [href]="story()" rmaMenuItem>{{ t('story') }}</a>
      <a [href]="reviews()" rmaMenuItem>{{ t('reviews') }}</a>
    </div>
  </ng-template>

  <ng-template #forMenuItems>
    <div class="flex flex-col gap-2 bg-white p-4 rounded-xl nc-glow-lg">
      <a [href]="group()" rmaMenuItem>{{ t('group') }}</a>
      <a [href]="agents()" rmaMenuItem>{{ t('agents') }}</a>
    </div>
  </ng-template>
</ng-container>
